import { render } from "./banner-group-template.vue?vue&type=template&id=12f96eb8&scoped=true"
import script from "./banner-group-template.vue?vue&type=script&lang=js"
export * from "./banner-group-template.vue?vue&type=script&lang=js"

import "./banner-group-template.vue?vue&type=style&index=0&id=12f96eb8&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f96eb8"]])

export default __exports__